<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect x="2.5" y="4" width="2" height="2" rx="0.941177" fill="currentColor" />
    <rect x="6.5" y="4" width="11" height="2" rx="0.941177" fill="currentColor" />
    <rect x="2.5" y="9" width="2" height="2" rx="0.941177" fill="currentColor" />
    <rect x="6.5" y="9" width="11" height="2" rx="0.941177" fill="currentColor" />
    <rect x="2.5" y="14" width="2" height="2" rx="0.941177" fill="currentColor" />
    <rect x="6.5" y="14" width="11" height="2" rx="0.941177" fill="currentColor" />
  </svg>
</template>
